import React, { useState } from "react";
import DropDown from "../common/DropDown";
import { useSearchParams } from "react-router-dom";
import CandidateSearch from "../search/CandidateSearch";
import CampaignSearch from "../search/CampaignSearch";
import CandidateTypeSearch from "../search/CandidateTypeSearch";
import { isMobile } from "../../utils/Utils";
import { BiFilterAlt } from "react-icons/bi";
import DrawerCommon from "../common/DrawerCommon";
import dayjs from "dayjs";
import { DatePicker } from "antd";

const Profession = [
  { value: "Non-HC", label: "Non-HC - Non Healthcare" },
  { value: "HC", label: "HC - Health Care" },
];

const Status = [
  { value: "Active", label: "Active" },
  { value: "Deactivated", label: "Inactive" },
  { value: "Deleted", label: "Deleted" },
];

const AuthenticationProvider = [
  { value: "EM", label: "EM" },
  { value: "FB", label: "FB" },
  { value: "Google", label: "Google" },
  { value: "Apple", label: "Apple" },
  { value: "LI", label: "LinkedIn" },
]

const Source = [
  { value: "Google", label: "Google" },
  { value: "null", label: "null" },
  { value: "Facebook", label: "Facebook" },
  { value: "Linkedin", label: "Linkedin" },
  { value: "IT Linkedin", label: "IT Linkedin" },
  { value: "Google_Display", label: "Google_Display" },
  { value: "IT Indeed", label: "IT Indeed" },
  { value: "website", label: "website" },
  { value: "SkillGigs IT Indeed", label: "SkillGigs IT Indeed" },
]

export default function CandidateFilter(
  { 
    profession, setProfession, 
    status, setStatus, 
    authenticationProvider, setAuthenticationProvider, 
    source, setSource,
    val, setVal,
    campaignVal, setCampaignVal,
    candidateTypeVal, setCandidateTypeVal
  }
) {

  const [open, setOpen] = useState(false);
  const detectMobile = isMobile();
  const [searchParams, setSearchParams] = useSearchParams();  

  const handleReset = () => {
    searchParams.delete("Professioncode");
    searchParams.delete("Status");
    searchParams.delete("private");
    searchParams.delete("AuthenticationProvider");
    searchParams.delete("Source");
    searchParams.delete("search");
    searchParams.delete("Campaign");
    searchParams.delete("PvtEmpIds");
    searchParams.set("page", 1);
    setVal("search");
    setCampaignVal("Campaign")
    setCandidateTypeVal("All Candidates")
    setSearchParams(searchParams);
    setProfession("Professions");
    setStatus("status");
    setAuthenticationProvider("AP");
    setSource("Sources");
  }

  const { RangePicker } = DatePicker;
  const handleDateChange = (dates) => {
    if (!(!dates || !dates[0] || !dates[1])) {
      let startDate = dayjs(dates[0].$d).format("MM-DD-YYYY");
      let endDate = dayjs(dates[1].$d).format("MM-DD-YYYY");
      searchParams.set("StartDate", startDate);
      searchParams.set("EndDate", endDate);
      setSearchParams(searchParams);
    }
    else {
      searchParams.delete("StartDate");
      searchParams.delete("EndDate");
      setSearchParams(searchParams);
    }
  };

  const handleChange = (type, value) => {
    switch (type) {

      case "profession":
        setProfession(value);
        searchParams.set("page", 1);
        searchParams.set("Professioncode", value);
        setSearchParams(searchParams);
        break;

      case "status":
        setStatus(value);
        searchParams.set("page", 1);
        searchParams.set("Status", value);
        setSearchParams(searchParams);
        break;

      case "AuthenticationProvider":
        setAuthenticationProvider(value);
        searchParams.set("page", 1);
        searchParams.set("AuthenticationProvider", value);
        setSearchParams(searchParams);
        break;

      case "Source":
        setSource(value);
        searchParams.set("page", 1);
        searchParams.set("Source", value);
        setSearchParams(searchParams);
        break;

      default:
        break;
    }

  };

  return (
    <div className="SearchAndFilterContainer">
      <div className="SearchFilterContainer">
        <CandidateSearch val={val} setVal={setVal} />
      </div>
      {!detectMobile ? <>
        <div className="DropdownFilterContainer">
          <DropDown
            options={Profession}
            defaultValue={"Professions"}
            width={120}
            handleSelect={handleChange}
            name={"profession"}
            value={profession}
          />
        </div>
        <div className="DropdownFilterContainer">
          <DropDown
            options={Status}
            defaultValue={"status"}
            width={120}
            handleSelect={handleChange}
            name={"status"}
            value={status}
          />
        </div>
        <div className="DropdownFilterContainer">
          <DropDown
            options={AuthenticationProvider}
            defaultValue={"Ap"}
            width={120}
            handleSelect={handleChange}
            name={"AuthenticationProvider"}
            value={authenticationProvider}
          />
        </div>
        <div className="DropdownFilterContainer">
          <DropDown
            options={Source}
            defaultValue={"Source"}
            width={120}
            handleSelect={handleChange}
            name={"Source"}
            value={source}
          />
        </div>
        <div className="SearchFilterContainer">
          <CampaignSearch val={campaignVal} setVal={setCampaignVal} />
        </div>
        <div className="SearchFilterContainer">
          <CandidateTypeSearch val={candidateTypeVal} setVal={setCandidateTypeVal} />
        </div>
        <span onClick={handleReset}>Clear Filter</span>
      </> : <>
        <div className="mobile-filter-icon">
          <BiFilterAlt size={20} color="#007cf0" onClick={() => setOpen(true)} />
        </div>
        <DrawerCommon title="Filter" open={open} setOpen={setOpen} >
          <div className="DropdownFilterWrapper">
            <div className="search-header-Drower-Profession">Profession  </div>
            <div className="DropdownFilterContainer">
              <DropDown
                options={Profession}
                defaultValue={"Professions"}
                handleSelect={handleChange}
                name={"profession"}
                value={profession}
              />
            </div>
            <div className="search-header-Drower-Profession">Status  </div>
            <div className="DropdownFilterContainer">
              <DropDown
                options={Status}
                defaultValue={"status"}
                handleSelect={handleChange}
                name={"status"}
                value={status}
              />
            </div>
            <div className="search-header-Drower-Profession">Authentication  </div>
            <div className="DropdownFilterContainer">
              <DropDown
                options={AuthenticationProvider}
                defaultValue={"Ap"}
                handleSelect={handleChange}
                name={"AuthenticationProvider"}
                value={authenticationProvider}
              />
            </div>
            <div className="search-header-Drower-Profession">Source  </div>
            <div className="DropdownFilterContainer">
              <DropDown
                options={Source}
                defaultValue={"Source"}
                handleSelect={handleChange}
                name={"Source"}
                value={source}
              />
            </div>
            <div className="search-header-Drower-Profession">Campaigns  </div>
            <div className="DropdownFilterContainer">
              <CampaignSearch val={campaignVal} setVal={setCampaignVal} />
            </div>
            <div className="search-header-Drower-Profession">All Candidates  </div>
            <div className="DropdownFilterContainer">
              <CandidateTypeSearch val={candidateTypeVal} setVal={setCandidateTypeVal} />
            </div>
            <div className="search-header-Drower-Profession">Date Range  </div>
            <div className="DropdownFilterContainer">
              <RangePicker
                suffixIcon={false}
                className="dateRangePicker"
                onChange={handleDateChange}
                format="MMM D, YYYY"
              />
            </div>
          </div>
          <span style={{ color: "#007cf0" }} onClick={handleReset}>Clear Filter</span>
        </DrawerCommon>
      </>
      }
    </div>
  );
}
